import React from 'react';
import { GridPageLayout } from '@lux/grid';
import { navigationItem } from '../../tokens/navigationItem';
import { track } from '../../lib/tracking';
import { Logo } from '../Logo';
import { LanguageSwitcher } from '../Header/LanguageSwitcher';
import { Wrapper, Container, LogoWrapper } from '../Header/styles';
const noopOnNavigationChange = (_) => { };
export const GuestHeader = (props) => {
    const { isPrive, supportedLanguages, onNavigationChange = noopOnNavigationChange, isCompact = false, ...rest } = props;
    return (React.createElement(Wrapper, { ...rest },
        React.createElement(GridPageLayout, null,
            React.createElement(Container, { isGuest: true, compact: isCompact },
                React.createElement(LanguageSwitcher, { supportedLanguages: supportedLanguages }),
                React.createElement(LogoWrapper, { isGuest: true, href: "/", isPrive: isPrive, onClick: () => {
                        track('Header_Header_Logo');
                        return onNavigationChange(navigationItem.homepage);
                    } },
                    React.createElement(Logo, { isPrive: isPrive }))))));
};
//# sourceMappingURL=index.js.map